import React from 'react'
import classNames from 'classnames'

import style from '@styles/form/TextField.module.scss'

interface Props {
  label: string
  inputId: string
  placeholder?: string
  type?: string
  error?: undefined | any
  errorMessages?: Record<string, string>
  containerStyles?: React.CSSProperties
}

const TextField = React.forwardRef(
  (
    { label, inputId, placeholder, type = 'text', error, errorMessages, containerStyles }: Props,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const hasError = error && error !== undefined

    return (
      <div className={style.container} style={containerStyles}>
        <label className={style.label} htmlFor={inputId}>
          {label}
        </label>
        <input
          className={classNames(style.field, { [style.fieldWithError]: hasError })}
          id={inputId}
          name={inputId}
          placeholder={placeholder}
          type={type}
          ref={ref}
        />
        {hasError && errorMessages && (
          <div className={style.errorMessage}>{errorMessages[error.type]}</div>
        )}
      </div>
    )
  }
)

export { TextField }
